export default __webpack_public_path__ + "static/giulia-dd5de5bc1910e3de97ac48700221349f.png";